<div *ngIf="!initialLoad">
  <p-panel header="Financials" styleClass="drill-down-section-header" [toggleable]="true">
    <div *ngIf="hasMultipleDatabases">
      <span class="ey-float-label">
        <select
          class="drill-down-dropdown form-select"
          #financialsSelect
          [ngModel]="selectedDatabaseId"
          (change)="onDatabaseChange(financialsSelect.value)"
          [disabled]="isLoading"
          appLabelFloat
        >
          <option *ngFor="let database of databases" [value]="database.id">
            {{ database.name }}
          </option>
        </select>
        <label>Database Source</label>
      </span>
    </div>
    <div class="drill-down-financials-header">
      <div class="drill-down-financials-header-item">
        <div class="item-label">Year Alignment</div>
        <div [innerHTML]="yearAlignment" class="item-value"></div>
      </div>
      <div class="drill-down-financials-header-item" *ngIf="currencyData">
        <div class="item-label">Currency</div>
        <div>
          <select
            [ngModel]="selectedCurrencyId"
            class="drill-down-currencies form-select"
            (change)="onCurrencyChange(currenciesSelect.value)"
            [disabled]="isLoading"
            #currenciesSelect
          >
            <option *ngFor="let currency of currencyData.currencies" [value]="currency.currencyId">
              {{ getCurrencyText(currency) }}
            </option>
          </select>
        </div>
      </div>
      <div class="drill-down-financials-header-item" *ngIf="currencyData">
        <div class="item-label">Currency Unit</div>
        <div class="item-value">
          {{ currencyData.currencyUnit }}
        </div>
      </div>
      <div class="drill-down-financials-header-item" *ngIf="!isNonBvd">
        <div class="item-label">Type of Financials:</div>
        <div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="drillDownUnconsolidated"
              name="typeOfFinancialsRadio"
              class="custom-control-input"
              (change)="onTypeOfFinancialsChange()"
              [value]="false"
              [ngModel]="selectedConsolidated"
              [disabled]="(selectedConsolidated && isTypeOfFinancialsReadOnly) || isLoading"
            />
            <label class="custom-control-label" for="drillDownUnconsolidated">Unconsolidated data</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="drillDownConsolidated"
              name="typeOfFinancialsRadio"
              class="custom-control-input"
              (change)="onTypeOfFinancialsChange()"
              [value]="true"
              [ngModel]="selectedConsolidated"
              [disabled]="(!selectedConsolidated && isTypeOfFinancialsReadOnly) || isLoading"
            />
            <label class="custom-control-label" for="drillDownConsolidated">Consolidated data</label>
          </div>
        </div>
      </div>
    </div>
    <div class="financial-section" [class.section-height]="isLoading">
      <div *ngIf="isLoading" class="financial-spinner">
        <app-spinner class="spinner" [class.spinner-center]="financials"></app-spinner>
      </div>
      <div *ngIf="financials && categoryNames.length !== 0">
        <p-tabView styleClass="financials-tabs">
          <p-tabPanel *ngFor="let categoryName of categoryNames; let i = index" [header]="formatName(categoryName)" [selected]="i === 0">
            <app-drill-down-financial-category
              [items]="financials[categoryName]"
              [headerRows]="headerRows"
              [tabName]="categoryName"
              [databaseId]="selectedDatabaseId"
            >
            </app-drill-down-financial-category>
          </p-tabPanel>
        </p-tabView>
      </div>
      <div *ngIf="!isLoading && !financials && isFinancialInitialLoaded" class="text-center">No results to display</div>
      <div *ngIf="!isLoading && !isFinancialInitialLoaded" class="reload-financials">
        <a (click)="reloadInitialFinancials()">reload</a>
      </div>
    </div>
  </p-panel>
</div>
